module.exports = __webpack_public_path__ + "img/layout_orange.3b58f35f.svg";